(() => {
  const root = document.querySelector('[data-r4-evidence]');
  if (!root || root.dataset.enhanced) return;
  root.dataset.enhanced = 'true';
  const search = root.querySelector('[data-r4-search]');
  const buyer = root.querySelector('[data-r4-buyer]');
  const system = root.querySelector('[data-r4-system-filter]');
  const cards = [...root.querySelectorAll('[data-r4-card]')];
  const update = () => {
    const query = search.value.trim().toLocaleLowerCase('en-US');
    let count = 0;
    const visible = new Set();
    cards.forEach(card => {
      const match = (!query || card.textContent.toLocaleLowerCase('en-US').includes(query)) &&
        (buyer.value === 'all' || card.dataset.audience === buyer.value) &&
        (system.value === 'all' || card.dataset.system === system.value);
      card.hidden = !match;
      if (match) { count++; visible.add(card.dataset.system); }
    });
    root.querySelectorAll('[data-r4-dependent]').forEach(el => {
      el.hidden = !visible.has(el.dataset.system);
    });
    root.querySelector('[data-r4-count]').textContent = `${count} of ${cards.length} systems shown`;
    root.querySelector('[data-r4-empty]').hidden = count !== 0;
    root.querySelector('[data-r4-comparison]').hidden = count === 0;
    root.querySelector('[data-r4-findings]').hidden = count === 0;
  };
  search.addEventListener('input', update);
  buyer.addEventListener('change', update);
  system.addEventListener('change', update);
  root.querySelector('[data-r4-reset]').addEventListener('click', () => {
    search.value = ''; buyer.value = 'all'; system.value = 'all'; update(); search.focus();
  });
  root.querySelector('[data-r4-export]').addEventListener('click', () => {
    const data = root.querySelector('[data-r4-ledger]').textContent;
    const url = URL.createObjectURL(new Blob([data], {type:'application/json'}));
    const link = document.createElement('a');
    link.href = url; link.download = 'drpenx-nano-system-source-analysis.json';
    document.body.appendChild(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  });
  const revealAnchor = hash => {
    const target = document.getElementById(hash.slice(1));
    const detail = target && target.closest('details');
    if (detail) detail.open = true;
  };
  root.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#r4-"]');
    if (link) revealAnchor(link.hash);
  });
  window.addEventListener('hashchange', () => revealAnchor(location.hash));
  revealAnchor(location.hash);
  root.querySelector('[data-r4-toolbar]').hidden = false;
  root.querySelector('[data-r4-export]').hidden = false;
  update();
})();
